import request from "lib/helpers/requestApi";

export const updateDSP = request({
    method: 'upload.sendDspRequest',
  });